import { useAccessToken } from './useAccessToken';
import { useLogger } from '../context/useLogger';
import { useMemo } from 'react';
import { ODataDsnsService } from '../services/ODataDsnsService';
import { useQuery } from '@tanstack/react-query';
import { DsnPaymentsResponse } from '../types/paiement.types';

export function useQueryPayments(
  instanceId: string | undefined,
  currentPage: number,
  pageSize: number,
) {
  const getAccessToken = useAccessToken();
  const logger = useLogger();

  const odataService = useMemo(
    () => new ODataDsnsService(getAccessToken, logger),
    [getAccessToken, logger],
  );

  const fetchDsnPayments = () => {
    if (!instanceId) {
      throw new Error('Instance ID is required');
    }
    logger.info('useQueryPayments [fetchDsnPayments] instanceId:', instanceId);
    logger.info('useQueryPayments [fetchDsnPayments] currentPage:', currentPage);
    logger.info('useQueryPayments [fetchDsnPayments] pageSize:', pageSize);

    const data: Promise<DsnPaymentsResponse> = odataService.fetchDsnPaymentList(
      instanceId,
      pageSize,
      currentPage,
    );

    return data;
  };

  logger.info('useQueryPayments instanceId:', instanceId);
  logger.info('useQueryPayments currentPage:', currentPage);
  logger.info('useQueryPayments pageSize:', pageSize);

  const queryKey = ['query-get', 'Payments', instanceId, currentPage, pageSize];
  const queryResult = useQuery({
    queryKey,
    queryFn: fetchDsnPayments,
    enabled: !!instanceId,
    throwOnError: (_error, query) => query.state.data === undefined,
  });

  logger.info('Query Key:', queryKey);
  logger.info('Query object:', queryResult);
  logger.info('Query Data:', queryResult?.data);
  logger.info('Query isFetching:', queryResult?.isFetching);

  return queryResult;
}
